import * as React from 'react';
import PageSection from 'components/success-stories/page-section/page-section';

function CtaButtonGroup({ ctaText, ctaLink, ctaTextTwo, ctaLinkTwo }: any) {
    // ctaLink && ctaLinkTwo
    return (
        <PageSection hasPadding={true} inner={false} extraClass="page--section-ambassadors-primary">
            <div className="wrapper black flex h-center v-center">
                <div className="apply-ctas flex h-center">
                    <a className="weight-bold" href={ctaLink} target="_blank" rel="noreferrer">
                        {ctaText}
                    </a>
                    <a className="weight-bold" href={ctaLinkTwo}>
                        {ctaTextTwo}
                    </a>
                </div>
            </div>
        </PageSection>
    );
}

export { CtaButtonGroup };
